import { Timestamp } from '@angular/fire/firestore';

export type DomainRequestType = 'cargosprint-subdomain' | 'custom-domain';

export enum DomainRequestStatus {
    NEW = 'new',
    PENDING = 'pending',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    ERROR = 'error',
}

export interface DomainRequest {
    requestId?: string;
    orgId: string;
    orgName: string;
    domainType: DomainRequestType;
    requestedDomain: string;
    subdomainLabel?: string;
    staticWebAppName?: string;
    status: DomainRequestStatus;
    createdAt: Date | Timestamp;
    updatedAt?: Date | Timestamp;
    updatedBy?: string;
    notes?: string;
}
